"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listResetMixin = void 0;
/** @mixin listResetMixin */
/**
 * Defensive reset styles for lists.
 *
 * @example
 * import { listResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.ul`
 *     ${listResetMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @return {CSSObject}
 */
var listResetMixin = function listResetMixin() {
  return "\n    margin: 0;\n    padding: 0;\n    list-style: none;\n";
};
exports.listResetMixin = listResetMixin;